import { tw } from '@/utils/tw';
import BaseArticleDisclosureLabelTheme from 'base/components/ArticleDisclosureLabel/theme';

const ArticleDisclosureLabel = tw.theme({
  extend: BaseArticleDisclosureLabelTheme,
  base: ['bg-linen-100', 'wings-linen-100', 'text-preamble-xs', 'text-black'],
});

export default ArticleDisclosureLabel;
